import moment from 'moment'
import Enum from '../enum'
import FilterMixin from './FilterMixin'
import permission from '../permission'
import FileUploader from '../components/FileUploader'
import {mapActions, mapState} from 'vuex'
import ErrorMessage from '../../components/ErrorMessage.vue'
import MomentDatePicker from '../components/MomentDatePicker'
import Multiselect from 'vue-multiselect'

var CrudMixin = {
  mixins: [FilterMixin],
  data() {
    return {
      CRUDMODE: Enum.Mode,
      error: '',
      ready: false,
      editors: new Map(),
    }
  },
  props: {
    compMode: {
      default: Enum.Mode.CREATE,
    },
  },
  created: function() {
    this.fetchData()
  },
  mounted: function() {
    this.setMode()
  },
  watch: {
    compMode: {
      handler(newVal, oldVal) {
        this.setMode()
      },
    },
  },
  methods: {
    ...mapActions(['persistFiles', 'persistPhoto']),
    download: function(content, fileName, mimeType) {
      var a = document.createElement('a')
      var universalBOM = '\uFEFF'
      content = universalBOM + content
      mimeType = mimeType || 'application/octet-stream'
      // IE10
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(new Blob([content], {type: mimeType}), fileName)
        //html5 A[download]
      } else if (URL && 'download' in a) {
        a.href = URL.createObjectURL(new Blob([content], {type: mimeType}))
        a.setAttribute('download', fileName)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        location.href = 'data:application/octet-stream,' + encodeURIComponent(content) // only this mime type is supported
      }
    },
    customDateFormatter(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    phoneRegex: function() {
      return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
    },
    processError: function(err, self, forceMessage) {
      if (err.response) {
        let response = JSON.parse(err.response)
        self.error = forceMessage ? forceMessage : response.message

        if (response.validationErrors !== null) {
          response.validationErrors.forEach(function(elementQQ) {
            elementQQ.members.forEach(function(member) {
              if (member == 'global' && !forceMessage) {
                self.error = elementQQ.message
              } else {
                var elem = self.$el.querySelector('input[name="' + member + '"]')
                var elemText = ''
                if (elem != undefined) elemText = elem.placeholder != undefined ? elem.placeholder : elem.name

                self.errors.add(member, elementQQ.message != '' ? elementQQ.message : elemText + ' invalide', 'required')
              }
            })
          })
        }

        $('html, body')
          .stop()
          .animate(
            {
              scrollTop: 0,
            },
            1000,
            'easeInOutExpo'
          )
      } else {
        console.log(err)
      }
    },
    cleanFields: function(object) {
      let dateRegex = new RegExp('[0-9]{2}[-|/]{1}[0-9]{2}[-|/]{1}[0-9]{4}')

      for (var propertyName in object) {
        if (object[propertyName] instanceof Object) {
          object[propertyName] = this.cleanFields(object[propertyName])
        } else {
          if (object[propertyName] === '') {
            object[propertyName] = undefined
          } else if (dateRegex.test(object[propertyName])) {
            object[propertyName] = moment(object[propertyName], 'DD/MM/YYYY')
          }
        }
      }
      return object
    },
    setMode: function() {
      if (this.compMode == Enum.Mode.READ) this.desactivateForm()
      else this.reactivateForm()
    },
    desactivateForm: function() {
      this.$el.querySelectorAll('input, select, textarea').forEach(function(elem) {
        elem.disabled = true
      })

      this.$el.querySelectorAll('input[type=checkbox]').forEach(function(elem) {
        elem.setAttribute('disabled', true)
      })

      this.$el.querySelectorAll('.multiselect').forEach(function(elem) {
        elem.classList.add('multiselect--disabled')
      })

      this.$el.querySelectorAll('.input-group-addon').forEach(function(elem) {
        elem.style.visibility = 'hidden'
      })
    },
    reactivateForm: function() {
      this.$el.querySelectorAll('input, select, textarea').forEach(function(elem) {
        elem.disabled = false
      })

      this.$el.querySelectorAll('input[type=checkbox]').forEach(function(elem) {
        elem.removeAttribute('disabled')
      })

      this.$el.querySelectorAll('.multiselect').forEach(function(elem) {
        elem.classList.remove('multiselect--disabled')
      })
      this.$el.querySelectorAll('.input-group-addon').forEach(function(elem) {
        elem.style.visibility = 'initial'
      })
    },
    checkCopyMode: function(entity) {
      if (this.compMode == Enum.Mode.COPY) {
        entity = this.cleanIds(entity)
      }
    },
    cleanIds: function(theObject) {
      if (theObject instanceof Object) {
        for (var prop in theObject) {
          if (prop == 'id') theObject[prop] = undefined
          if (prop == 'associatedUserId') theObject[prop] = undefined

          if (theObject[prop] instanceof Object) theObject[prop] = this.cleanIds(theObject[prop])
        }
      }
      return theObject
    },
    getErrorMessage: function(err) {
      return err.message + ' - ' + JSON.parse(err.response).message
    },
  },
  components: {
    'file-uploader': FileUploader,
    errorMessage: ErrorMessage,
    'moment-date-picker': MomentDatePicker,
    multiselect: Multiselect,
  },
}
export default CrudMixin



// WEBPACK FOOTER //
// ./src/shared/Mixin/CrudMixin.js